import { Card, List, Svg } from '@repo/ui';

interface Props {
  onClick: () => void;
  bg?: boolean;
}

export const OngoingRefundButton = ({ onClick, bg = false }: Props) => {
  return (
    <Card className="mt-normal-large rounded-bzc-large !px-normal-large py-tiny-large hover:cursor-pointer" outline={false} onClick={onClick}>
      <List
        title="진행중인 환급 목록 보기"
        size="small"
        className="!p-normal-small"
        leadingElement={<Svg width={32} height={32} src="icg_moneybag_md.svg" />}
        supportingElement={<Svg width={18} height={18} src="ic_chevron-right.svg" />}
      />
    </Card>
  );
};
